import React from 'react';
import { Visibility, VisibilityOff } from '@mui/icons-material';

interface SubMenuProps {
  items: { key: string; label: string; subtitle?: string }[];
  active: string;
  onChange: (_key: string) => void;
  isSuperAdmin?: boolean;
  visiblePolicies?: string[];
  onToggleVisibility?: (_key: string) => void;
}

export const SubMenu: React.FC<SubMenuProps> = ({ items, active, onChange, isSuperAdmin, visiblePolicies, onToggleVisibility }) => {
  // Non-superadmin: filter to only visible policies (undefined = all visible)
  const displayItems = isSuperAdmin
    ? items
    : items.filter((item) => !visiblePolicies || visiblePolicies.includes(item.key));

  return (
    <div className="flex flex-col w-60 bg-white shadow-md min-h-0">
      <div className="flex p-3 border-b border-b-gray-125 font-semibold text-gray-700 flex-shrink-0">Policies</div>
      <div className="overflow-y-auto flex-1">
      {displayItems.map((item) => {
        const isVisible = !visiblePolicies || visiblePolicies.includes(item.key);
        return (
          <div key={item.key} className="flex items-center border-b border-b-gray-125">
            {isSuperAdmin && (
              <button
                onClick={(e) => { e.stopPropagation(); onToggleVisibility?.(item.key); }}
                className="px-2 py-2.5 text-gray-300 hover:text-gray-500 transition-colors flex-shrink-0"
                title={isVisible ? 'Visible to client' : 'Hidden from client'}
              >
                {isVisible
                  ? <Visibility sx={{ fontSize: 16 }} className="text-gray-400" />
                  : <VisibilityOff sx={{ fontSize: 16 }} className="text-gray-300" />
                }
              </button>
            )}
            <button
              onClick={() => onChange(item.key)}
              className={`flex-1 text-left px-3 py-2.5 border-l-4 hover:bg-red-300 hover:bg-opacity-5 ${
                active === item.key ? 'border-red font-bold' : 'border-transparent'
              } ${!isVisible && isSuperAdmin ? 'opacity-40' : ''}`}
            >
              <span className="text-sm">{item.label}</span>
              {item.subtitle && (
                <span className="block text-[10px] text-gray-400 font-normal leading-tight mt-0.5">{item.subtitle}</span>
              )}
            </button>
          </div>
        );
      })}
      </div>
    </div>
  );
};

export default SubMenu;
